import Vue from "vue";
import Router from "vue-router";
import Participant from "./views/Participant.vue";
import Home from "./views/Home.vue";
import EndMeeting from "./views/EndMeeting.vue";
import Reject from "./views/Reject.vue";
import Page404 from "./views/Page404.vue";
import WaitingRoom from "./views/WaitingRoom.vue";
import InputInfo from "./views/InputInfo.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",  
  mode:'history',
  //history:createWebHistory(),
  //history: createWebHashHistory(),
  routes: [
    {
      path: "/participant",
      name: "Participant",
      components: {
        default: Participant,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
    },
    {
      path: "/end_meeting",
      name: "EndMeeting",
      components: {
        default: EndMeeting,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
    },
    {
      path: "/reject",
      name: "Reject",
      components: {
        default: Reject,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
    },
    {
      path: "/page404",
      name: "Page404",
      components: {
        default: Page404,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
    },
    {
      path: "/waiting_room",
      name: "WaitingRoom",
      components: {
        default: WaitingRoom,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
    },
    {
      path: "/input_info",
      name: "InputInfo",
      components: {
        default: InputInfo,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
    },
    {
      path: "/",
      name: "Home",
      components: {
        default: Home,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
    },
    {
      //https://stackoverflow.com/questions/40193634/vue-router-redirect-on-page-not-found-404
      path: "*",
      redirect:'/page404',
      /*
      name: "PageNOTFound",
      components: {
        default: Page404,
      },
      meta: {
        //title: "JUD " + process.env.VUE_APP_TITLE,
        title: process.env.VUE_APP_HTML_TITLE,
      },
      */
    },
  ],
  /*
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  */
});
